<template>
    <keep-alive>
      <div class="order-list" id="order-list">

        <!-- 搜索 -->
        <div class="serch-box">
          <van-cell-group>
            <van-field
                v-model.trim="params.name"
                required
                label="姓名"
                placeholder="投保人/被保人姓名"
            />
            <van-field
                v-model.trim="params.idCode"
                required
                label="证件号"
                placeholder="投保人/被保人证件号"
            />
            </van-cell-group>
            <van-button @click="onSearch" type="primary" v-if="btnLoading" block>点击查询<br><span style="font-size: 10px; color: #eee; font-weight: 300;">( 默认查询最近3天的订单数据 )</span></van-button>
            <van-button
              type="primary"
              block
              loading
              loading-text="查询中"
              v-else
            ></van-button>
            <!-- <div class="hint-tip">提醒：默认查询最近3个月的订单数据</div> -->
        </div>

        <!-- <textarea style="white-space: pre-line;" v-model="text" name="" id="" cols="30" rows="10"></textarea> -->

        <!-- tab -->
        <!-- <div class="tabs-box">
          <van-tabs @click="clickTab">
            <van-tab title="所有订单" name=""></van-tab>
            <van-tab title="待支付" name="0"></van-tab>
            <van-tab title="已支付" name="1"></van-tab>
            <van-tab title="已退款" name="2"></van-tab>
          </van-tabs>
        </div> -->
        
        <!-- dataList -->
        <div class="data-list" id="data-list">
          <div class="item" v-for="(item,index) in orderList.list" :key="index" @click="gotoDetail(item)">
            <div class="top">
              <div class="ordernum">订单号：{{item.tradeNo?item.tradeNo:'暂未生成保单'}}</div>
              <div class="status" :class="{blue:item.status == 0,red:item.status == 2,green:item.status == 1}">状态：{{item.status == 0?'待支付':""}}{{item.status == 1?'已支付':""}}{{item.status == 2?'已退保':""}}</div>
            </div>
            <div class="center">
              <div class="left">
                <img src="http://fimage.huaxiyou.cc/upload/image/20200629/1593403557557018657.png" alt="">
              </div>
              <div class="right">
                <div class="title">{{item.title}}</div>
                <div class="insured">被保人：{{item.TipName}}</div>
                <div class="time">投保时间：{{moment(item.createTime).format("YYYY-MM-DD hh:mm:ss")}}</div>
                <div class="timerange">保障期限：{{moment(item.startDate).format("YYYY-MM-DD HH:mm")}} 至 {{moment(item.endDate).format("YYYY-MM-DD HH:mm")}}</div>
                <!-- <div class="price-y">
                  <span style="font-size:12px">价格：￥{{item.totalPrice}}</span>
                </div> -->
                <!-- <div class="price">
                  <span style="font-size:14px;color:red">实付款：￥{{item.payPrice}}</span>
                  <span  style="font-size:12px;color:#AEAEAE">（已优惠¥{{(Number(item.totalPrice) - Number(item.payPrice)).toFixed(2)>0?(Number(item.totalPrice) - Number(item.payPrice)).toFixed(2):0}}）</span>
                </div> -->
              </div>
            </div>
            <div class="bot" v-if="false">
              <div class="more">
                <img src="./assets/images/more.png" alt="">
              </div>
              <div class="btns">
                <div class="btn" v-if="item.status == 0">立即支付</div>
              </div>
            </div>
            <!-- 下载保单 -->
             <div style="width:100%;height:30px" v-if="showBalance != 2 && item.status == 1 && item.insuranceResult == '投保成功' && item.num == 1">
               <button style="float:right;line-height:22px;margin-top:3px" @click.stop="exportFile(item)">下载保单</button>
              </div>
          </div>
          <van-empty v-if="noData" description="暂时没有该类数据～～" />
          <!-- <div class="loading" v-if="isLoading">
            加载中...
          </div> -->
        </div>
      </div>
    </keep-alive>
</template>

<script>
import storejs from "store";
import moment from 'moment';
import { Search,Tab, Tabs,Empty,Field,CellGroup,Button,Toast  } from 'vant';
import $ from "jquery";
import util from "@/libs/util";

export default {
  name: 'OrderList',
  components: {
    [Search.name]: Search,
    [Tab.name]:Tab,
    [Tabs.name]:Tabs,
    [Empty.name]:Empty,
    [Field.name]:Field,
    [CellGroup.name]:CellGroup,
    [Button.name]:Button,
    [Toast.name]:Toast
  },
  data(){
    return{
      moment:moment,
      publicData: storejs.get("publicData"),
      queryKey:"",
      text:"",
      params:{
        queryKey:'',
        pageNumber:1,
        pageSize:4,
        status:'',
        name:'',
        idCode:''
      },
      orderList:{
        list: [],
        pagination: {}
      },
      isLoading:false,
      noData:false,
      btnLoading:true,
      showBalance: 1,
      filterName: '',
      filterCode: '',
    }
  },
  watch: {
    // async text(){
    //   console.log(this.text)
    //   let res = await this.$http.post("api/insuranceProduction/parsePasteInfo", {content:this.text});
    // }
  },
  mounted() {
    document.title = '订单列表'
    this.showBalance = this.$route.query.showBalance ? this.$route.query.showBalance : 1;
    this.initStyle()
    this.init()
    this.$nextTick(()=>{
      // window.addEventListener('scroll', this.scroll)
    //   this.onToBottom(() => {
    //     this.getOrderList()
    //   });
    })
    
  },
  beforeDestroy: function() {
    window.removeEventListener('scroll', this.scroll)
    // this.scroll = null
  },
  methods: {
    initStyle(){
      // let el = document.getElementById('bg')
      let height = window.innerHeight
      $('#order-list').css({'min-height':height + 'px'})
    },
    async init(){
    //   await this.getOrderList()
    },
    gotoDetail(item){
      this.$router.push({
        name:'OrderDetail',
        query:{
          id:item.id,
          c:this.$route.query.c,
          fixedOrNot: this.$route.query.fixedOrNot,
          filterName: this.filterName,
          filterCode: this.filterCode,
        }
      })
    },
    async getOrderList(){
      if(this.isLoading) return
      this.isLoading = true
      this.noData = false
      let res = ''
      console.log('getOrderList',this.$route.query.accountId)
      if(this.$route.query.accountId){
        this.params.accountId=util.encryptId(this.$route.query.accountId)
        this.params.companyId=this.$route.query.companyId
        res = await this.$http.post("api/bill/getBillsByAccountId", this.params); 
      }else{
        if(!this.publicData){
          this.$router.push({
            name:'Login'
          })
        }
        this.params.accountId=(this.publicData.parentId == 0? this.publicData.id:this.publicData.parentId)
        this.params.companyId=this.publicData.companyId
        this.params.subAccountId=this.publicData.parentId == 0? this.publicData.parentId:this.publicData.id
        let obj = {token:util.cookies.get('token')}
        res = await this.$http.post("api/bill/getListByCustomer", {...this.params,...obj});
      }
      if(res.code == 0){
        if(res.t.length > 0){
          this.filterName = this.params.name;
          this.filterCode = this.params.idCode;
          res.t.forEach((el)=>{
              // el.insurePeople = JSON.parse(el.insurePeople)
              if(!!el.togetherInfos){
                try {
                  el.togetherInfos = JSON.parse(el.togetherInfos)
                  if(el.togetherInfos.length){
                      let arr = []
                      el.togetherInfos.forEach((item,index)=>{
                          if(index<3){
                              arr.push(item.n)
                          }
                      })
                      el.TipName = arr.join(',') + '等' + el.num + '人'
                      console.log('tipname',el.TipName)

                  } 
                } catch (error) {
                  
                }
              }else{
                  el.TipName = el.name + '等' + el.num + '人'
              }
          })
          this.orderList.list = [...this.orderList.list,...res.t]
          this.orderList.pagination = res.pagination
          this.params.pageNumber ++
        }else{
          // this.$toast.fail(res.msg)
          if(this.params.pageNumber == 1){
            this.noData = true
          }
        }
      }else{
         if(res.msg){
          this.$toast(res.msg);
        }
      }
      this.btnLoading = true
      this.isLoading = false
      console.log('isLoading_1233',res)
    },
    onSearch(){
     if(!this.params.name){
        this.btnLoading = true
        this.$toast("请输入姓名");
          return
      }
      if(!this.params.idCode){
        this.btnLoading = true
        this.$toast("请输入证件号");
        return
      }
      // if(this.params.name.length <= 0 && this.params.idCode.length <= 0){
      //   this.$toast('请输入查询条件');
      //   return;
      // }
      this.btnLoading = false
      this.params.queryKey = this.queryKey
      this.params.pageNumber = 1
      // this.params.startDate = new Date().getTime() - 31536000000
      this.params.startDate = new Date().getTime() - 24*3600*1000*3
      this.params.endDate = new Date().getTime()
      this.orderList ={
        list: [],
        pagination: {}
      }
      this.getOrderList()
    },
    clickTab(name, title){
      console.log(name,title)
      this.params.status = name
      this.params.pageNumber = 1
      this.orderList ={
        list: [],
        pagination: {}
      }
      this.getOrderList()
    },
    getScrollTop(params) {
      let scrollTop = 0;
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop;
      } else if (document.body) {
        scrollTop = document.body.scrollTop;
      }
      return scrollTop;
    },
    onToBottom(callback) {
      let that = this;
      var scrollToBottom = {
        getScrollTop: this.getScrollTop,
        getScrollHeight: function() {
          var scrollHeight = 0,
            bodyScrollHeight = 0,
            documentScrollHeight = 0;
          if (document.body) {
            bodyScrollHeight = document.body.scrollHeight;
          }
          if (document.documentElement) {
            documentScrollHeight = document.documentElement.scrollHeight;
          }
          scrollHeight =
            bodyScrollHeight - documentScrollHeight > 0
              ? bodyScrollHeight
              : documentScrollHeight;
          return scrollHeight;
        },
        getClientHeight: function() {
          var windowHeight = 0;
          if (document.compatMode == "CSS1Compat") {
            windowHeight = document.documentElement.clientHeight;
          } else {
            windowHeight = document.body.clientHeight;
          }
          return windowHeight;
        },
        onScrollEvent: function(callback) {
          var This = this;
          //window.scrollTo(0,document.body.scrollHeight)
          window.onscroll = function() {
            if (
              This.getScrollTop() + This.getClientHeight() >=
              This.getScrollHeight()
            ) {
              typeof callback == "function" && callback.call(this);
            }
          };
        }
      };
      scrollToBottom.onScrollEvent(function() {
        if (typeof callback === "function") {
          callback();
        }
      });
    },

    scroll() {
      if (
        document.body.scrollTop + window.innerHeight >=
        document.body.offsetHeight
      ) {
        this.getOrderList()
      }
    },
    // scroll() {//也有效
    //   let wScrollY = window.scrollY; // 滚动条位置
    //   let WInnerH = window.innerHeight // 设备窗口的高度
    //   var bScrollH = document.body.scrollHeight;  //  滚动条的总高度
    //   if (wScrollY + WInnerH >= bScrollH) {          
    //     this.params.pageNumber ++
    //     this.getOrderList()
      
    //   }  
    //   // let scrollTop = $(window).scrollTop();
    //   // let scrollHeight = $(document).height();
    //   // let windowHeight = $(window).height();
    //   // if(scrollTop + windowHeight == scrollHeight){
    //   //     alert(66)
    //   //     this.params.pageNumber ++
    //   //     this.getOrderList()
    //   // }
		// },
    
    exportFile(item) {
      // let billIdValue = util.encryptId(item.id);
      // let accountIdValue = '';
      // if(this.$route.query.accountId){
      //   accountIdValue = util.encryptId(this.$route.query.accountId);
      // }else{
      //   if(this.publicData){
      //     let loginUserId = this.publicData.parentId == 0 ? this.publicData.id : this.publicData.parentId;
      //     accountIdValue = util.encryptId(loginUserId);
      //   }
      // }
      const LOADING = Toast.loading({
        message: '下载中...',
        forbidClick: true,
        loadingType: 'spinner',
      });
      if(item.insuranceCid == 20 || item.insuranceCid == 25 || item.insuranceCid == 26){
        //下载保单：链接形式
        console.log('下载保单：链接形式')
        this.$http.post("/api/accountBill/prints.v2", {
          insuranceCode: item.insuranceCode, 
        }).then(res => {
          LOADING.clear();
          if(res){
            if(res.t){
              window.open(res.t, "_blank");
            }else{
              if(res.msg){
                this.$toast.fail(res.msg)
              }  
            }
          }
        }).catch(err => {
          LOADING.clear();
          if(err && err.msg){
            this.$toast.fail(err.msg)
          }
        })
      }else{
        //下载保单：文件形式
        setTimeout(() => {
          LOADING.clear();
        }, 1500);
        console.log('下载保单：文件形式')
        let downUrl = `${location.origin}/api/accountBill/prints.v2?insuranceCode=${item.insuranceCode}`
        window.open(downUrl, "_blank")
      }
    },
  },
}

function isFileStream(file) {
  return file instanceof Blob || file instanceof File;
}
</script>

<style lang="scss" scoped>
  .order-list{
    font-size: 14px;
    background: #FAFAFA;
    //搜索
    .serch-box{
      width: 100%;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 100;
      background: #00E59E;
    }

    //tab
    .tabs-box{
      width: 100%;
      position: fixed;
      top: 54px;
      left: 0;
      right: 0;
      z-index: 100;
    }
    // 数据列表
    .data-list{
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;
      padding-top: 140px;
      .item{
        width: 100%;
        background:rgba(255,255,255,1);
        border-radius:8px;
        padding: 10px;
        box-sizing: border-box;
        margin: 10px 0;
        .top{
          display: flex;
          justify-content: space-between;
          .ordernum{
            font-size:12px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(102,102,102,1);
          }
          .status{
            font-size:12px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(0,211,133,1);
            &.blue{
              color: #999999;
            }
            &.red{
              color: red;
            }
            &.green{
              color:rgba(0,211,133,1);
            }
          }
        }
        .center{
          display: flex;
          margin-top: .1rem;
          .left{
            width: .7rem;
            flex-shrink: 0;
            margin-right: .1rem;
            img{
              width: 100%;
              border-radius: 10px;
            }
          }
          .right{
            flex: 1;
            .title{
              font-size:14px;
              font-family:PingFangSC-Medium,PingFang SC;
              font-weight:500;
              color:rgba(51,51,51,1);
              line-height: 20px;
            }
            .insured,.time,.timerange,.price-y{
              font-size:12px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:rgba(174,174,174,1);
              line-height: 20px;
            }
            .price{
              display: flex;
              justify-content: flex-end;
            }
          }
        }
        .bot{
          display: flex;
          justify-content: space-between;
          height: 40px;
          align-items: center;
          .more{
            img{
              width: 20px;
            }
          }
          .btns{
            .btn{
              width:.64rem;
              height:.24rem;
              border-radius:4px;
              border:1px solid rgba(0,211,133,1);
              font-size:12px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:rgba(0,211,133,1);
              display: flex;
              justify-content: center;
              align-items: center;
              &.red{
                border-color: red;
                color: red;
              }
            }
          }
        }
      }
    }
  }
  .hint-tip{
    background: #fafafa;
    padding: 8px 12px 4px;
    font-size: 11px;
    color: orange;
  }
</style>

<style lang="scss">
  .order-list{
    .serch-box{
      .van-search{
        background: #00E59E;
        .van-search__content{
          background:rgba(226,254,247,1);
          border-radius:6px;
        }
        .van-icon-search{
          color: rgba(186,186,186,1);;
        }
        .van-search__action{
          color: #fff;
        }
      }
    }
    .van-tabs__line{
      background: #00D385;
    }
    .van-tab--active{
      color: #00D385;
    }
  }
</style>